
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.554 2.023a1.707 1.707 0 0 0-1.732-.27L1.888 7.783a1.703 1.703 0 0 0 .087 3.181l3.021 1.051 1.684 5.568a.833.833 0 0 0 .099.21c.006.01.015.018.022.027a.823.823 0 0 0 .234.222c.08.052.167.09.26.113l.01.001.005.002a.851.851 0 0 0 .168.017l.016-.002a.827.827 0 0 0 .25-.044c.02-.006.036-.017.054-.025a.829.829 0 0 0 .17-.095l.127-.107 2.252-2.486 3.358 2.602c.296.23.66.355 1.035.355a1.711 1.711 0 0 0 1.673-1.36l2.719-13.348a1.691 1.691 0 0 0-.578-1.642zM7.81 12.28a.828.828 0 0 0-.227.422l-.258 1.253-.654-2.16 3.388-1.765-2.25 2.25zm6.918 4.42-3.97-3.074a.834.834 0 0 0-1.127.099l-.721.796.255-1.239 5.902-5.902a.833.833 0 0 0-.974-1.329l-8.471 4.411-3.104-1.136L17.5 3.333 14.727 16.7z","fill":"#fff"}})])
          )
        }
      }
    